<div class="edit-tax-dialog-container">
  <div class="edit-tax-dialog-header">
    <h1>
      {{ ((selectedTax$ | async) ? 'SETTINGS.TAXES.FORM.EDIT_TAX' : 'SETTINGS.TAXES.FORM.CREATE_TAX') | translate }}
    </h1>
    <gb-icon icon="close" (click)="closeDialog()"></gb-icon>
  </div>
  <form [formGroup]="editTaxForm">
    <gb-form-field [control]="taxLabel" labelTranslateKey="SETTINGS.TAXES.FORM.TAX_LABEL"></gb-form-field>
    <gb-form-field
      [control]="taxPercentage"
      labelTranslateKey="SETTINGS.TAXES.FORM.TAX_PERCENTAGE"
      type="number"
    ></gb-form-field>

    <gb-select-form-field
      [control]="taxMethod"
      [options$]="taxMethodOptions$"
      displayProperty="name"
      valueProperty="method"
      labelTranslateKey="SETTINGS.TAXES.FORM.TAX_METHOD"
    ></gb-select-form-field>

    <div>
      <mat-checkbox [formControl]="autoApplyTaxToItems">{{
        'SETTINGS.TAXES.FORM.APPLY_TO_NEW_ITEMS' | translate
      }}</mat-checkbox>
      <mat-hint>{{ 'SETTINGS.TAXES.FORM.APPLY_TO_NEW_ITEMS_HINT' | translate }}</mat-hint>
    </div>

    @if (!(selectedTax$ | async)) {
      <div>
        <mat-checkbox [formControl]="autoApplyTaxToExistingItems">{{
          'SETTINGS.TAXES.FORM.APPLY_TO_EXISTING_ITEMS' | translate
        }}</mat-checkbox>
        <mat-hint>{{ 'SETTINGS.TAXES.FORM.APPLY_TO_EXISTING_ITEMS_HINT' | translate }}</mat-hint>
      </div>
    }
  </form>
</div>

<div class="gb-flex-button-container gb-dialog-actions-container">
  <button mat-stroked-button (click)="closeDialog()" translate="CANCEL"></button>
  <button [disabled]="(createEditLoaded$ | async) === false" mat-flat-button (click)="submit()">
    <gb-button-loader [loaded$]="createEditLoaded$">
      <span>{{ 'SAVE' | translate }}</span>
    </gb-button-loader>
  </button>
</div>
